<mat-chip selectable="false" [removable]="canBeDeleted()" (removed)="emitRemove()">
  <mat-icon fontSet="fontastic" fontIcon="icon-ic-needed-file-v2"></mat-icon>
  {{ attachmentName() }}
  @if (canBeDeleted()) {
    <mat-icon matChipRemove inline="true" fontSet="fontastic" fontIcon="icon-close-2c-r-24-fontastic"></mat-icon>
  }
</mat-chip>
